export const walletConstants = {
    GETUSERWALLET_REQUEST: 'WALLET_GETUSERWALLET_REQUEST',
    GETUSERWALLET_SUCCESS: 'WALLET_GETUSERWALLET_SUCCESS',
    GETUSERWALLET_FAILURE: 'WALLET_GETUSERWALLET_FAILURE',  
};

export const tickerConstants = {
    GETTICKER_SUCCESS: 'WALLET_GETTICKER_SUCCESS',
    GETTICKER_FAILURE: 'WALLET_GETTICKER_FAILURE',  
};

export const currencyTypeConstants = {
    CURRENCYTYPE_DIGITAL_ASSET : 'DigitalAsset' , 
    CURRENCYTYPE_CASH : 'Cash' , 
    CURRENCYTYPE_STABLECOIN : 'StableCoin' ,
};


// WEBPACK FOOTER //
// ./src/_constants/wallet.constants.js